import { useEffect } from "react";
import { replace } from "connected-react-router";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { transactionStatus } from "pages/transactions/constants";

export const useConfirmTransaction = (transactionData, transactionTicket, route, noBack = false) => {
    const dispatch = useDispatch();
    const { state } = useLocation();
    const history = useHistory();
    useEffect(() => {
        if (noBack) {
            return;
        }
        if (isEmpty(transactionData)) {
            history.goBack();
        }
    }, []);

    useEffect(() => {
        const isCancel =
            transactionData?.cancelTransaction ||
            transactionData?.cesionData?.cancelTransaction ||
            transactionData?.cesionData?.cesionData?.cancelTransaction;

        if (isCancel) {
            return;
        }
        const { status, idTransaction, idTransactionToCancel } = transactionTicket;
        const idToUse = idTransactionToCancel || idTransaction;
        if (status === transactionStatus.PENDING && idToUse) {
            dispatch(replace(`/${route}/pending/${idToUse}`, { isFlowComplete: true, ...state }));
        }
        if (status === transactionStatus.FINISHED && idToUse) {
            dispatch(replace(`/${route}/success/${idToUse}`, { isFlowComplete: true, ...state }));
        }
        if (status === transactionStatus.SCHEDULED && idToUse) {
            dispatch(replace(`/${route}/schedule/${idToUse}`, { isFlowComplete: true, ...state }));
        }
        if (status === transactionStatus.PROCESSING && idToUse) {
            dispatch(replace(`/${route}/processing/${idToUse}`, { isFlowComplete: true, ...state }));
        }
        if (status === transactionStatus.CANCELLED && idToUse) {
            dispatch(replace(`/${route}/cancelled/${idToUse}`, { isFlowComplete: true, ...state }));
        }
        if (status === transactionStatus.PENDING_BACKOFFICE && idToUse) {
            dispatch(replace(`/${route}/pending/${idToUse}`, { isFlowComplete: true, ...state }));
        }
        if (status === transactionStatus.FAILED && idToUse) {
            dispatch(replace(`/${route}/failed/${idToUse}`, { isFlowComplete: true, ...state }));
        }
    }, [transactionTicket]);

    return { dispatch, history };
};

export default useConfirmTransaction;
